module.exports = __webpack_public_path__ + "img/Check-Circle-Fill.0408af81.svg";